import styled from 'styled-components';

const ContainerDetails = styled.div`
  padding: 16px;
  width: 175px;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #282828;
  padding-top: 6px;
  padding-bottom: 8px;
`;

const DeliveryDate = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: #868686;
  margin-top: 8px;
`;
export { ContainerDetails, Title, DeliveryDate };
